import amplitude from 'amplitude-js';

export interface amplitudeData {
  agentFullName?: string;
  agentEmail?: string;
  hasImage?: boolean;
  hasBio?: boolean;
  cityName?: string | null;
  zipCode?: number | null;
}

export const AMPLITUDE_INSTANCE_ID = 'agent-dir';

export const initializeAmplitude = (): void => {
  if (amplitude && process.env.REACT_APP_AMPLITUDE_API_KEY) {
    amplitude.getInstance(AMPLITUDE_INSTANCE_ID).init(process.env.REACT_APP_AMPLITUDE_API_KEY);
  }
};

export function logAmplitudeEvent(eventName: string, data?: amplitudeData): Promise<number> {
  return new Promise((resolve) => {
    if (amplitude) {
      amplitude.getInstance(AMPLITUDE_INSTANCE_ID).logEvent(eventName, data, resolve);
    }
  });
}
